import React from "react";
import ExcelPreviewCanvas from "./ExcelPreviewCanvas";

interface ExcelPreviewModalProps {
  excelFileType: string;
  excelBlob: Blob;
  setIsXlsModalOpen: (value: React.SetStateAction<boolean>) => void;
  setExcelBlob: (value: React.SetStateAction<Blob | null>) => void;
  anomalyData?: any;
}

const ExcelPreviewModal: React.FC<ExcelPreviewModalProps> = ({
  excelFileType,
  excelBlob,
  setIsXlsModalOpen,
  setExcelBlob,
  anomalyData,
}) => {
  const closeModal = () => {
    setIsXlsModalOpen(false);
    // if (anomalyData) return;
    setExcelBlob(null); // Clear file when closed
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-3/4 h-[90%] flex flex-col">
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold">
            {excelFileType == "xlsx" ? "Excel" : "CSV"} Preview
          </h2>
          <button
            type="button"
            onClick={closeModal}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="flex-grow overflow-hidden rounded-lg">
          <ExcelPreviewCanvas file={excelBlob} anomalyData={anomalyData} />
        </div>
      </div>
    </div>
  );
};

export default ExcelPreviewModal;
